/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useRef, useState, useEffect } from "react";
import format from "date-fns/format";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import { useAuth } from "react-oidc-context";

import { useNitroStore } from "../../../../../store/Store";
import { useNitroCAStore } from "../../../../../store/CompetitiveAnalysisStore";
import { useFavoriteOrigins } from "../../../../../hooks/useFavoriteOrigins";
import { useQuotesForDestinations } from "../../../../../hooks/useQuotesForDestinations";
import { useQuotesForDestinationsOld } from "../../../../../hooks/useQuotesForDestinationsOld";
import { useQuotesForSurroundingLocations } from "../../../../../hooks/useQuotesForSurroundingLocations";
import { useQuotesForSurroundingLocationsOld } from "../../../../../hooks/useQuotesForSurroundingLocationsOld";
import MonthFilterButton from "../../../../../components/filters/MonthFilterButton";
import CompanyFilter from "../../../../../components/filters/CompanyFilter";
import LocationExpandedFilter from "../../../../../components/filters/LocationExpandedFilter";
import ProductMobileFilter from "./productMobilFilter";
import SetupOriginsWarning from "../../../../../components/filters/SetupOriginsWarning";
import MobileFavoriteOriginsPanel from "../../../../../panels/mobile/mobileFavoriteOriginPanel/mobileFavoriteOriginPanel";
import "./mobileFilter.css";
import { ISurroundingLocationsParams } from "../../../../../types/ICompAnalysisQMD";
import { icons } from "../../../../../svg";
import MultiLocSearchPanel from "../../../../../panels/mobile/multiLocSearchPanel/multiLocSearchPanel";
import MultiLocQuotePanel from "../../../../../panels/mobile/multiLocQuotePanel/multiLocQuotePanel";
import MobileSplitFavoriteOriginsPanel from "../../../../../panels/mobile/originManagerPanel/mobileSplitFavoriteOriginPanel";

const MobileFilter = ({
  tempParty,
  setTempParty,
  tempCity,
  setTempCity,
  tempState,
  setTempState,
  tempLocation,
  setTempLocation,
  tempMonth,
  setTempMonth,
  tempSearchType,
  setTempSearchType,
  search,
  hasChange,
  product,
  setProduct,
  mode,
  setMode,
  onSearchableChange,
  onOpenChange,
  externalOpen,
  setExternalOpen,
  panelsOnly,
  onFooterSelect,
}: {
  tempParty: string;
  setTempParty: (value: string) => void;
  tempCity: string;
  setTempCity: (value: string) => void;
  tempState: string;
  setTempState: (value: string) => void;
  tempLocation: string;
  setTempLocation: (value: string) => void;
  tempMonth: string;
  setTempMonth: (value: string) => void;
  tempSearchType: "location" | "company";
  setTempSearchType: (value: "location" | "company") => void;
  search: (mobileValues?: {
    party?: string;
    city?: string;
    state?: string;
    location?: string;
    month?: string;
  }) => void;
  hasChange: boolean;
  product: string;
  setProduct: (value: string) => void;
  mode: string;
  setMode: (value: string) => void;
  onSearchableChange?: (isSearchable: boolean) => void;
  onOpenChange?: (isOpen: boolean) => void;
  externalOpen?: boolean;
  setExternalOpen?: (open: boolean) => void;
  panelsOnly?: boolean;
  onFooterSelect?: (tab: any) => void;
}) => {
  const [
    selectedProduct,
    showMobileSearchPanel,
    setShowMobileSearchPanel,
    showMobileFavoriteOriginPanel,
    setShowMobileFavoriteOriginPanel,
  ] = useNitroStore((state: any) => [
    state.product,
    state.showMobileSearchPanel,
    state.setShowMobileSearchPanel,
    state.showMobileFavoriteOriginPanel,
    state.setShowMobileFavoriteOriginPanel,
  ]);

  const [initialQuery, setInitialQuery] = useState("");

  const [internalOpen, setInternalOpen] = useState(false);
  const open = externalOpen ?? internalOpen;

  const setOpen = (value: boolean) => {
    if (setExternalOpen) {
      setExternalOpen(value);
    } else {
      setInternalOpen(value);
    }
  };

  const auth = useAuth();
  const user = `${auth.user?.profile.given_name ?? ""} ${
    auth.user?.profile.family_name ?? ""
  }`.trim();

  const [currentFilters, setFilters] = useNitroStore((state: any) => [
    state.currentFilters,
    state.setFilters,
  ]);
  const [
    uom,
    currency,
    selectedMobileDestination,
    setSelectedMobileDestination,
  ] = useNitroStore((state: any) => [
    state.uom,
    state.currency,
    state.selectedMobileDestination,
    state.setSelectedMobileDestination,
  ]);
  const [refetchMultiLocation, triggerRefetchMultiLocation] = useNitroCAStore(
    (state) => [state.refetchMultiLocation, state.triggerRefetchMultiLocation],
  );
  const {
    showWarning,
    kochOrigins,
    competitorOrigins,
    kochPrices,
    competitorPrices,
  } = useFavoriteOrigins(user, product);

  const [featureFlags] = useNitroStore((state: any) => [state.featureFlags]);
  const { originManager } = featureFlags;

  useEffect(() => {
    if (!product || !onSearchableChange) return;

    const searchDisabled =
      kochOrigins.length === 0 ||
      competitorOrigins.length === 0 ||
      kochPrices.length === 0 ||
      competitorPrices.length === 0;

    onSearchableChange(searchDisabled);
  }, [
    product,
    kochOrigins,
    competitorOrigins,
    kochPrices,
    competitorPrices,
    onSearchableChange,
  ]);

  const [showWarningPanel, setShowWarningPanel] = useState(showWarning);
  const [displayFavoriteOriginPanel, setDisplayFavoriteOriginPanel] =
    useState(false);

  useEffect(() => {
    if (!displayFavoriteOriginPanel) {
      setShowWarningPanel(showWarning);
    }
  }, [showWarning, displayFavoriteOriginPanel]);

  useEffect(() => {
    if (onOpenChange) {
      onOpenChange(open);
    }
  }, [open, onOpenChange]);

  const companyRef = useRef(null);
  const locationRef = useRef(null);
  const monthRef = useRef(null);
  const [priorityProducts] = useNitroStore((state: any) => [
    state.priorityProducts,
  ]);

  const handleGoBack = () => {
    setShowWarningPanel(false);
  };

  const handleSetupOrigins = () => {
    setShowWarningPanel(false);
    setDisplayFavoriteOriginPanel(true);
  };

  const mobileQueryParams: any = {
    id:
      tempSearchType === "location"
        ? tempCity || tempState || tempLocation || null
        : null,
    product: product || "AMMONIA",
    party: tempSearchType === "company" ? tempParty || null : null,
    marketer: user,
    shipDate: tempMonth,
    currency,
    uom,
  };

  // Both hooks are always called (rules of hooks); the inactive one is disabled and skips its fetch.
  const newQuotes = useQuotesForDestinations(
    mobileQueryParams,
    refetchMultiLocation,
    !originManager,
  );
  const oldQuotes = useQuotesForDestinationsOld(
    mobileQueryParams,
    refetchMultiLocation,
    originManager,
  );
  const { destinationQuotes, loading } = originManager ? newQuotes : oldQuotes;

  const locationParams: ISurroundingLocationsParams = {
    party_id: tempSearchType === "company" ? tempParty || "" : "",
    citystate_id:
      tempSearchType === "location"
        ? tempCity || tempState || tempLocation || ""
        : "",
    product: product || "UAN",
    marketer: user,
    shipDate: tempMonth,
    currency,
    uom,
  };

  const useSurroundingLocationsQuotes = originManager
    ? useQuotesForSurroundingLocations
    : useQuotesForSurroundingLocationsOld;

  const {
    surroundingQuotes,
    loading: isLoadingSurroundingQuotes,
    error: surroundingQuotesError,
  } = useSurroundingLocationsQuotes(locationParams, refetchMultiLocation);

  const hasActiveFilters =
    currentFilters.party ||
    currentFilters.city ||
    currentFilters.state ||
    currentFilters.location;

  const [currentView, setCurrentView] = useState<"search" | "quote">("search");
  const [returnToView, setReturnToView] = useState<"quote" | null>(null);
  const [originManagerReturnView, setOriginManagerReturnView] = useState<
    "quote" | null
  >(null);
  const [selectedCompany, setSelectedCompany] = useState<string>("");
  const [quoteData, setQuoteData] = useState<any[]>([]);

  const handleInitialInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInitialQuery(e.target.value);
    if (!showMobileSearchPanel && setShowMobileSearchPanel) {
      setShowMobileSearchPanel(true);
    }
  };

  const handleResultClick = (
    searchValue: string,
    searchType: "location" | "company",
    clickedDestinationQuotes: any[] = [],
    clickedSurroundingLocations: any[] = [],
  ) => {
    if (searchType === "company") {
      setSelectedCompany(searchValue);
      setTempParty(searchValue);
      setTempCity("");
      setTempState("");
      setTempLocation("");
    } else {
      setSelectedCompany(searchValue);
      setTempCity(searchValue);
      setTempParty("");
    }
    setTempSearchType(searchType);
    setQuoteData(clickedDestinationQuotes);
    setCurrentView("quote");
  };

  const handleSearchCancel = () => {
    if (returnToView === "quote") {
      setCurrentView("quote");
      setReturnToView(null);
    } else {
      setInitialQuery("");
      if (setShowMobileSearchPanel) {
        setShowMobileSearchPanel(false);
      }
      if (onFooterSelect) {
        onFooterSelect("origins");
      }
    }
  };

  const handleQuoteBack = (searchQuery?: string) => {
    const queryToSet = searchQuery || selectedCompany;
    setInitialQuery(queryToSet);
    setCurrentView("search");
    setReturnToView("quote");
    setSelectedMobileDestination(null);
    if (setShowMobileSearchPanel) {
      setShowMobileSearchPanel(true);
    }
  };

  const handleOpenOrigins = () => {
    if (setShowMobileSearchPanel) {
      setShowMobileSearchPanel(false);
    }
    setShowMobileFavoriteOriginPanel(true);
    setDisplayFavoriteOriginPanel(true);
    setOriginManagerReturnView("quote");
    if (onFooterSelect) {
      onFooterSelect("origins");
    }
  };

  const handleCloseOriginManager = () => {
    setDisplayFavoriteOriginPanel(false);
    setShowMobileFavoriteOriginPanel(false);

    if (originManagerReturnView === "quote") {
      setCurrentView("quote");
      setShowMobileSearchPanel?.(true);
    }

    setOriginManagerReturnView(null);
  };

  const handleCloseAllPanels = () => {
    setDisplayFavoriteOriginPanel(false);
    setShowMobileFavoriteOriginPanel(false);
    setCurrentView("search");
    setSelectedCompany("");
    setOriginManagerReturnView(null);
    if (setShowMobileSearchPanel) {
      setShowMobileSearchPanel(false);
    }
  };

  const handleOriginManagerFooterSelect = (tab: any) => {
    if (tab === "quote" && originManagerReturnView === "quote") {
      setDisplayFavoriteOriginPanel(false);
      setShowMobileFavoriteOriginPanel(false);
      setCurrentView("quote");
      setOriginManagerReturnView(null);
      if (setShowMobileSearchPanel) {
        setShowMobileSearchPanel(true);
      }
      return;
    }

    setOriginManagerReturnView(null);
    if (onFooterSelect) {
      onFooterSelect(tab);
    }
  };

  const getSearchDisplayText = () => {
    if (
      currentFilters.party &&
      (currentFilters.city || currentFilters.state || currentFilters.location)
    ) {
      return `${currentFilters.party} in ${
        currentFilters.city || currentFilters.state || currentFilters.location
      }`;
    }
    return (
      currentFilters.party ||
      currentFilters.city ||
      currentFilters.state ||
      currentFilters.location ||
      ""
    );
  };

  // On mobile (panelsOnly), only show overlay when search panel is explicitly opened
  const shouldShowOverlay = panelsOnly
    ? showMobileSearchPanel
    : open || showMobileSearchPanel;

  return (
    <>
      <div
        style={{
          display: shouldShowOverlay ? "flex" : "none",
          flexDirection: "column",
          position: "fixed",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: showMobileSearchPanel
            ? "transparent"
            : "rgba(15, 44, 82, 0.5)",
          zIndex: showMobileSearchPanel ? 10003 : 100,
        }}
        id="location-product-search-panel"
      >
        {open && !showMobileSearchPanel && (
          <div
            style={{
              height: "100dvh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              paddingBottom: "env(safe-area-inset-bottom)",
            }}
            id="location-menu"
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                setOpen(false);
              }
            }}
          >
            <div
              style={{
                borderRadius: 0,
                display: "flex",
                flexDirection: "column",
                backgroundColor: "white",
                height: "100%",
                width: "100%",
                justifyContent: "flex-start",
                flex: "0 1 auto",
              }}
              id="location-search-menu-column"
            >
              <div
                id="location-search-menu-outline"
                style={{
                  padding: "20px 30px",
                  display: "flex",
                  flexDirection: "column",
                  gap: 15,
                  flex: "0 1 auto",
                  overflowY: "auto",
                }}
              >
                {/* Header Row */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingBottom: 5,
                    borderBottom: "1px solid #e0e0e0",
                    marginBottom: 5,
                  }}
                >
                  <div
                    style={{
                      fontSize: "1.2em",
                      fontWeight: "600",
                      color: "#333",
                    }}
                    id="search-location-button"
                  >
                    Search
                  </div>
                  <IconButton
                    onClick={() => {
                      setFilters({
                        city: "",
                        location: "",
                        state: "",
                        party: "",
                      });
                      setTempParty("");
                      setTempCity("");
                      setTempState("");
                      setTempLocation("");
                      setTempMonth(format(new Date(), "yyyy-MM-dd"));
                      setProduct("");
                      search({
                        party: "",
                        city: "",
                        state: "",
                        location: "",
                        month: format(new Date(), "yyyy-MM-dd"),
                      });
                      setOpen(false);
                    }}
                    sx={{
                      padding: "4px",
                      "&:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.04)",
                      },
                    }}
                  >
                    <ClearIcon sx={{ fontSize: "20px" }} />
                  </IconButton>
                </div>

                {/* Filter Sections */}
                <div
                  className="mobile-filter-section"
                  id="who-search-menu"
                  onClick={() => {
                    (companyRef?.current as any)?.focus();
                  }}
                >
                  <div className="mobile-filter-label" id="who-button">
                    Who
                  </div>
                  <div className="mobile-filter-content" id="company-filter">
                    <CompanyFilter
                      value={tempParty}
                      setValue={(value: string) => setTempParty(value || "")}
                      config={{
                        inputRef: companyRef,
                      }}
                      isMobile
                      type="popup"
                    />
                    {tempParty && (
                      <IconButton
                        sx={{ height: 54, width: 40, borderRadius: 0 }}
                        onClick={() => setTempParty("")}
                      >
                        <ClearIcon />
                      </IconButton>
                    )}
                  </div>
                </div>

                <div
                  className="mobile-filter-section"
                  id="search-function-where"
                  onClick={() => {
                    (locationRef?.current as any)?.focus();
                  }}
                >
                  <div className="mobile-filter-label" id="where">
                    Where
                  </div>
                  <div
                    className="mobile-filter-content"
                    id="location-expanded-filter"
                  >
                    <LocationExpandedFilter
                      isMobile
                      config={{
                        inputRef: locationRef,
                      }}
                      value={tempCity || tempState || tempLocation}
                      setValue={(type: string, value: string) => {
                        if (type === "clear") {
                          setTempCity("");
                          setTempState("");
                          setTempLocation("");
                          return;
                        }
                        if (type === "city") {
                          setTempCity(value);
                          setTempState("");
                          setTempLocation("");
                        } else if (type === "state") {
                          setTempCity("");
                          setTempState(value);
                          setTempLocation("");
                        } else if (type === "facility") {
                          setTempCity("");
                          setTempState("");
                          setTempLocation(value);
                        } else {
                          setTempCity("");
                          setTempState("");
                          setTempLocation("");
                        }
                        search({
                          party: tempParty,
                          city: type === "city" ? value : "",
                          state: type === "state" ? value : "",
                          location: type === "facility" ? value : "",
                          month: tempMonth,
                        });
                      }}
                    />
                    {(tempCity || tempState || tempLocation) && (
                      <IconButton
                        sx={{ height: 54, width: 40, borderRadius: 0 }}
                        onClick={() => {
                          setTempCity("");
                          setTempState("");
                          setTempLocation("");
                        }}
                      >
                        <ClearIcon />
                      </IconButton>
                    )}
                  </div>
                </div>

                <div
                  className="mobile-filter-section"
                  id="month-filter-button"
                  onClick={() => {
                    (monthRef?.current as any)?.focus();
                  }}
                >
                  <div className="mobile-filter-label">When</div>
                  <div className="mobile-filter-content-end">
                    <MonthFilterButton
                      inputRef={monthRef}
                      value={tempMonth}
                      setValue={setTempMonth}
                      isMobile
                    />
                  </div>
                </div>

                <div className="mobile-additional-filters">
                  <ProductMobileFilter
                    selectedProduct={product}
                    setSelectedProduct={setProduct}
                    products={priorityProducts}
                  />
                </div>

                {showWarningPanel && (
                  <SetupOriginsWarning
                    onGoBack={handleGoBack}
                    onSetupOrigins={handleSetupOrigins}
                  />
                )}
              </div>

              <div
                style={{
                  backgroundColor: "white",
                  padding: "20px 10px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderTop: "1px solid #e0e0e0",
                  boxSizing: "border-box",
                  flexShrink: 0,
                  flex: "0 1 auto",
                }}
                id="product-filter-search-row"
              >
                <Button
                  id="mobileFilterClearButton"
                  size="large"
                  onClick={() => {
                    setTempParty("");
                    setTempCity("");
                    setTempState("");
                    setTempLocation("");
                    setTempMonth(format(new Date(), "yyyy-MM-dd"));
                  }}
                >
                  Clear
                </Button>
                <Button
                  id="mobileFilterSearchButton"
                  size="large"
                  variant="contained"
                  onClick={() => {
                    search();
                    setOpen(false);
                  }}
                >
                  Search
                </Button>
              </div>
            </div>
          </div>
        )}

        {showMobileSearchPanel && (
          <>
            {currentView === "search" && (
              <MultiLocSearchPanel
                key="multi-loc-search-panel"
                onCancel={handleSearchCancel}
                onResultClick={(
                  value: string,
                  searchType: "location" | "company",
                  quotes: any[] = [],
                  locations: any[] = [],
                ) => handleResultClick(value, searchType, quotes, locations)}
                selectedMonth={tempMonth}
                selectedProduct={product}
                initialQuery={initialQuery}
                onSearchTextChange={setInitialQuery}
              />
            )}

            {currentView === "quote" && (
              <MultiLocQuotePanel
                companyName={selectedCompany}
                quotes={quoteData}
                setQuotes={setQuoteData}
                setSurroundingLocs={() => {}}
                surroundingLocs={surroundingQuotes}
                onBack={handleQuoteBack}
                selectedProduct={product}
                setSelectedProduct={setProduct}
                selectedMonth={tempMonth}
                setSelectedMonth={setTempMonth}
                onOpenOrigins={handleOpenOrigins}
                loading={loading}
                triggerRefetch={triggerRefetchMultiLocation}
                hookDestinationQuotes={destinationQuotes}
                hookSurroundingLocations={surroundingQuotes}
                selectedDestination={selectedMobileDestination}
                setSelectedDestination={setSelectedMobileDestination}
              />
            )}
          </>
        )}
      </div>

      {!panelsOnly && !showMobileSearchPanel && (
        <div
          style={{
            minWidth: 250,
            width: "100%",
            display: "flex",
            alignItems: "center",
            backgroundColor: "white",
            height: 50,
            borderRadius: 30,
            boxShadow: "0px 4px 4px 0px #0000004D, 0px 8px 12px 6px #00000026",
            cursor: "text",
            overflow: "hidden",
            ...{
              position: "relative",
            },
          }}
          id="set-open"
          onClick={() => {
            setOpen(true);
          }}
        >
          <div
            style={{
              paddingLeft: 18,
              minWidth: 27,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              ...{
                position: hasActiveFilters ? "relative" : "absolute",
                left: hasActiveFilters ? "auto" : 18,
              },
            }}
          >
            {hasActiveFilters ? (
              <img
                src={icons.SearchMagnifyingGlass}
                alt="Search Magnifying Glass Icon"
              />
            ) : (
              <svg
                width="27"
                height="27"
                viewBox="0 0 27 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.035766 7.7557C0.071532 15.5114 0.071532 15.5114 0.362171 16.6167C1.88572 22.4111 6.40748 26.3067 12.3613 26.9541C13.501 27.078 15.7338 26.9356 16.1511 26.7124C16.4494 26.5528 16.3875 13.1631 16.0855 12.5181C15.4252 11.1078 14.767 10.7882 12.522 10.7882H10.8035L10.7756 15.9148C10.7445 21.6177 10.2047 22.0396 7.35534 18.5872C5.7333 16.6218 5.56811 15.8607 5.51527 10.1092L5.47252 5.45851L10.125 5.50327C16.2111 5.56188 17.2046 5.83712 19.3212 8.05047C21.3332 10.1548 21.4903 10.9054 21.4903 18.4167C21.4903 22.2742 21.5272 24.26 21.5987 24.26C21.8972 24.26 23.8963 22.2147 24.6198 21.1691C29.8564 13.6003 26.0472 3.06675 17.1544 0.525456C15.3998 0.0240454 14.9459 0 7.24675 0H0L0.035766 7.7557Z"
                  fill="#09B0F2"
                />
              </svg>
            )}
          </div>

          <div
            id="mobile-start-search"
            className="start-search-container"
            style={{
              paddingLeft: 0,
              width: "100%",
              marginLeft: "-10%",
              display: "flex",
              flexDirection: "column",
              position: "relative",
            }}
          >
            {!hasActiveFilters && (
              <img
                src={icons.SearchMagnifyingGlass}
                alt="Search Magnifying Glass Icon"
              />
            )}

            <div
              className={hasActiveFilters ? "start-search-with-month" : ""}
              style={{ position: "relative", width: "100%", height: "100%" }}
            >
              <input
                id="search-input-id"
                type="text"
                value={initialQuery}
                onChange={handleInitialInput}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  opacity: 0,
                  cursor: "text",
                  zIndex: 10,
                }}
              />

              <div className="start-search-text">
                {getSearchDisplayText() || "Start your search"}
              </div>

              {hasActiveFilters && (
                <div className="start-search-month">
                  {currentFilters.month
                    ? `${format(
                        new Date(`${currentFilters.month}T00:00:00`),
                        "MMM yy",
                      )} - ${selectedProduct || "AMMONIA"}`
                    : "When"}{" "}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {!showMobileSearchPanel &&
        (showMobileFavoriteOriginPanel || displayFavoriteOriginPanel) &&
        (originManager ? (
          <MobileSplitFavoriteOriginsPanel
            onSearchableChange={onSearchableChange}
            onClose={handleCloseOriginManager}
            onCloseAll={handleCloseAllPanels}
            onFooterSelect={handleOriginManagerFooterSelect}
            selectedMonth={tempMonth}
            setSelectedMonth={setTempMonth}
          />
        ) : (
          <MobileFavoriteOriginsPanel
            onSearchableChange={onSearchableChange}
            onClose={handleCloseOriginManager}
            onCloseAll={handleCloseAllPanels}
            onFooterSelect={handleOriginManagerFooterSelect}
            selectedMonth={tempMonth}
            setSelectedMonth={setTempMonth}
          />
        ))}
    </>
  );
};

export default MobileFilter;
